import taythrifts_0 from "../../images/projects/taythrifts/0.PNG";
import taythrifts_1 from "../../images/projects/taythrifts/1.PNG";
import taythrifts_2 from "../../images/projects/taythrifts/2.PNG";
import taythrifts_3 from "../../images/projects/taythrifts/3.PNG";
import taythrifts_4 from "../../images/projects/taythrifts/4.PNG";
import taythrifts_5 from "../../images/projects/taythrifts/5.PNG";
import taythrifts_6 from "../../images/projects/taythrifts/6.PNG";
import taythrifts_7 from "../../images/projects/taythrifts/7.PNG";
import taythrifts_8 from "../../images/projects/taythrifts/8.PNG";
import taythrifts_9 from "../../images/projects/taythrifts/9.PNG";
import taythrifts_10 from "../../images/projects/taythrifts/10.PNG";
import taythrifts_11 from "../../images/projects/taythrifts/11.PNG";
import taythrifts_12 from "../../images/projects/taythrifts/12.PNG";
import taythrifts_13 from "../../images/projects/taythrifts/13.PNG";
import taythrifts_14 from "../../images/projects/taythrifts/14.PNG";
import taythrifts_15 from "../../images/projects/taythrifts/15.PNG";
import taythrifts_16 from "../../images/projects/taythrifts/16.PNG";
import taythrifts_17 from "../../images/projects/taythrifts/17.PNG";
import taythrifts_18 from "../../images/projects/taythrifts/18.PNG";
import taythrifts_19 from "../../images/projects/taythrifts/19.PNG";
import taythrifts_20 from "../../images/projects/taythrifts/20.PNG";

export default function taythriftsImages() {
  return [
    taythrifts_0,
    taythrifts_1,
    taythrifts_2,
    taythrifts_3,
    taythrifts_4,
    taythrifts_5,
    taythrifts_6,
    taythrifts_7,
    taythrifts_8,
    taythrifts_9,
    taythrifts_10,
    taythrifts_11,
    taythrifts_12,
    taythrifts_13,
    taythrifts_14,
    taythrifts_15,
    taythrifts_16,
    taythrifts_17,
    taythrifts_18,
    taythrifts_19,
    taythrifts_20,
  ];
}
